import React, {useCallback, useEffect, useState} from 'react'
import bem from '../../helpers/bem'
import {ButtonBack, ButtonNext, Slide, Slider, WithStore} from "pure-react-carousel"
import Player from "../player"
import {getHighestWinPercent, isActivePlayer} from "../../helpers/board"
import {usePrevious} from "../../hooks/common"

const Carousel = (props) => {
  const {
    removeCard,
    activeField,
    setActiveField,
    setChosenCard,
    isNotWinnerPlayer,
    isPOC,
    isWinnerCard,
    setCardsMenu,
    noCommunityCards,
    hiLo,
    players,
    isSlidesOverflow,
    winner,
    carouselStore,
    currentSlide,
    isSplitPotWinner,
    isOddsWinner,
    carousel,
    setBoardCarousel,
  } = props;
  const block = 'board';
  const prevCurrentSlide = usePrevious(currentSlide);
  const currentCarouselStore = carouselStore.getStoreState();
  const prevCarouselStore = usePrevious(currentCarouselStore);

  useEffect(() => {
    const currentTotalSlides = currentCarouselStore.totalSlides;
    if ((prevCarouselStore && prevCarouselStore.totalSlides) > currentTotalSlides) {
      switch (currentTotalSlides) {
        case 2:
          carouselStore.setStoreState({currentSlide: 0});
          break;
        default:
          if (currentCarouselStore.visibleSlides === 3) {
            carouselStore.setStoreState({currentSlide: currentTotalSlides - 3});
          } else {
            carouselStore.setStoreState({currentSlide: currentTotalSlides - 2});
          }
          break;
      }
    }
  }, [carouselStore, currentSlide, prevCarouselStore, prevCurrentSlide, currentCarouselStore]);

  const getOddsWinner = useCallback(() => {
    return isPOC
      ? players.find(player => parseFloat(player.win) === getHighestWinPercent(players))
      : players.find(player => winner && winner.ids.includes(player.id));
  }, [players, isPOC, winner]);
  const [oddsWinner, setOddsWinner] = useState(getOddsWinner());
  const prevOddsWinner = usePrevious(getOddsWinner());
  useEffect(() => {
      const currentOddsWinner = getOddsWinner();
      if (carousel && carousel.hasChanged && carousel.reset) {
        setBoardCarousel({hasChanged: false, reset: false});
        carouselStore.setStoreState({currentSlide: 0});
      }
      if (currentOddsWinner && carousel && carousel.hasChanged) {
        setBoardCarousel({hasChanged: false});
        const currentTotalSlides = currentCarouselStore.totalSlides;
        switch (currentTotalSlides) {
          case 2:
            carouselStore.setStoreState({currentSlide: 0});
            break;
          default:
            if (currentCarouselStore.visibleSlides === 3) {
              if (currentOddsWinner.id >= 3) {
                carouselStore.setStoreState({currentSlide: currentOddsWinner.id - 3});
              } else {
                carouselStore.setStoreState({currentSlide: 0});
              }
            } else if (currentCarouselStore.visibleSlides === 1) {
              carouselStore.setStoreState({currentSlide: currentOddsWinner.id - 1});
            } else {
              if (currentOddsWinner.id >= 2) {
                carouselStore.setStoreState({currentSlide: currentOddsWinner.id - 2});
              } else {
                carouselStore.setStoreState({currentSlide: 0});
              }
          }
            break;
        }
      }
    },
    [oddsWinner, setOddsWinner, players, currentCarouselStore, prevOddsWinner, carouselStore, getOddsWinner, carousel, setBoardCarousel]
  );
  return (
    <React.Fragment>
      <Slider>
        {players.map((player, index) => {
          return <Slide
            index={index}
            key={player.id}
            className={bem({block, elem: 'slide'})}
          >
            <div
              className={bem({block, elem: 'player', mods: {[player.id]: true}})}
              key={player.id}
            >
              <Player
                player={player}
                removeCard={removeCard}
                activeField={isActivePlayer(players, player, activeField, winner)}
                splitPotWinner={isSplitPotWinner(player.id)}
                oddsWinner={isOddsWinner(player.win)}
                isNotWinnerPlayer={isNotWinnerPlayer(player)}
                setActiveField={setActiveField}
                setChosenCard={setChosenCard}
                isWinnerCard={isWinnerCard}
                index={index}
                isPOC={isPOC}
                noCommunityCards={noCommunityCards}
                hiLo={hiLo}
                setCardsMenu={setCardsMenu}
                slider
              />
            </div>
          </Slide>
        })}
      </Slider>
      <div className={bem({
        block,
        elem: 'slider-buttons',
        mods: {'visible': isSlidesOverflow, 'is-poc': isPOC}
      })}>
        <ButtonBack
          className={bem({block, elem: 'slider-back-button', mods: {'is-poc': isPOC}})}
        />
        <ButtonNext
          className={bem({block, elem: 'slider-next-button', mods: {'is-poc': isPOC}})}
        />
      </div>
    </React.Fragment>
  )
};

export default WithStore(Carousel, state => {
  return ({
    currentSlide: state.currentSlide
  })
});